<template>
  <div
    class="menu_item"
    :class="{active: isActive}"
    @click="handleClick"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  data: () => ({
    isActive: false,
  }),

  props: {
    delay: {
      type: Number,
    },
    closeDelay: {
      type: Number,
    },
    showMenu: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    showMenu() {
      // 最初の表示時は実行されない
      setTimeout(() => {
        this.isActive = false;
      }, this.closeDelay);
    },
  },

  mounted() {
    setTimeout(() => {
      this.isActive = true;
    }, this.delay);
  },

  methods: {
    handleClick() {
      this.$emit('clickItem');
    },
  },
};
</script>

<style lang="scss" scoped>
.menu_item{
  cursor: pointer;
  transition: .4s;
  position: relative;
  left: 0;
  background-color: $white;
  width: 100%;
  height: 40px;
  color: $black;
  margin: 3px 0;
  animation: slide-in 1s forwards;
  display: flex;
  justify-content: center;
  align-items: center;
  animation-delay: 3.5s;
  transform: translateX(-150%);
  &.active {
    left: 0;
    transform: translateX(0%);
  }
  &:before {
    content: "";
    position: absolute;
    left: 14px;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: $white;
    transform: skewX(-25deg);
    z-index: -1;
  }
  &:hover {
    text-decoration: underline;
  }
}
</style>
